import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import CustomSelect from '../Utilities/CustomSelect'
import { EmpListsVM } from '../../Structure/ViewModels/Admin/EmpListsVM'

const ListEmployee = (props:{user:{id:string , name:string , email:string , employee_key:string},role:{id:string , role:string},roles:{id:string , role:string}[],index:number, vm:EmpListsVM}) => {
const [vm,setVm] = useState<{viewModel:EmpListsVM}>({viewModel:props.vm})
  const control = vm.viewModel
  useEffect(()=>control.subscribeUpdate(setVm),[])
  const [edit, setEdit] = useState<boolean>(false)
  const [availble , setAvailble] = useState<boolean>(true)

  const [name , setName] = useState<string>(props.user.name)
  const [email , setEmail] = useState<string>(props.user.email)
  const [role , setRole] = useState<string>(props.role.id)
  const [password , setPassword] = useState<string>('')

  const refresh = ()=>{
    control.reLocateUser(props.user.id , name , email , role)
  }

return (
    availble?(
    edit?(
        <Row className='py-2 justify-content-center' style={{background:props.index%2?'rgba(250,250,250,1)':'rgba(240,240,240,1)'}}>
            <Col md={6} className='px-3 py-1'>
                <input type="text" className='input-field w-100' value={name} onChange={a=>setName(a.target.value) } />
            </Col>
            <Col md={6} className='px-3 py-1'>
                <input type='email' className='input-field w-100' value={email}  onChange={a=>setEmail(a.target.value) } />
            </Col>
            <Col md={6} className='px-3 py-1'>
                <input type='password' className='input-field w-100' value={password} onChange={a=>setPassword(a.target.value) } placeholder='كلمة السر' />
            </Col>
            <Col md={6} className='px-3 py-1'>
                <CustomSelect list={props.roles.map(i=>({label:i.role , value:i.id}))} selected={role} onSelect={a=>setRole(a)}/>
            </Col>
            <Col md={6} className='px-3 py-3 d-flex justify-content-center'>
                <button className='button-II bg-success text-white px-5 py-1 mx-2' onClick={()=>{ setEdit(false); control.editUser(props.user.id , name , email , password , role); refresh(); }}>حفظ</button>
                <button className='button-II bg-danger text-white px-5 py-1 mx-2' onClick={()=>setEdit(false)}>الغاء</button>
            </Col>
        </Row>
    ):(
    <Row className='py-2' style={{background:props.index%2?'rgba(250,250,250,1)':'rgba(240,240,240,1)'}}>
        <Col md={4} className=' justify-content-center py-2'>
            <div className='d-flex justify-content-between'>
                <h6>{props.user.name}</h6>
                <h6 className='px-4'>{props.user.employee_key}</h6>
            </div>
        </Col>
        <Col md={4} className=' justify-content-center  py-2'>
            <div className='d-flex justify-content-center'>
                <h6>{props.user.email}</h6>
            </div>
        </Col>
        <Col md={4} className=' justify-content-center  py-2'>
            <div className='d-flex justify-content-around'>
                <div className="material-symbols-outlined fw-bold text-success c-pointer" onClick={()=>setEdit(true)}>
                    settings
                </div>
                <div className="material-symbols-outlined fw-bold text-danger c-pointer"  onClick={()=>control.passwordReset(props.user.id, props.user.name)}>
                    reset_settings  
                </div>
                {
                    props.user.employee_key==='5001'||props.user.employee_key==='5002'?(null):(
                <div className="material-symbols-outlined fw-bold text-danger c-pointer" onClick={()=>{ setAvailble(false); control.deleteUser(props.user.id, props.user.name); }}> 
                    delete 
                </div>
                )
            }
            </div>
        </Col>
    </Row>)
    ):(null)
  )
}

export default ListEmployee
